import Handlebars from 'handlebars'
import moment from 'moment'
import 'moment/locale/nl'
import handlebarsHelpers from 'handlebars-helpers'
const helpers = handlebarsHelpers([
  'math',
  'number',
  'string',
  // 'date',
  'comparison',
  'array',
  'object'
])

const getTemplateVariables = (invoiceInput, invoiceSettingsInput) => {
  const dateHelper = function (date, options) {
    let format
    let hash
    if (typeof options === 'string') {
      format = options
      hash = {}
    } else {
      hash = options.hash
      format = options.hash.format || options.hash.formaat || 'LL'
    }
    const language =
      hash.language || hash.taal || invoiceSettingsInput.language || 'nl'
    date = date || new Date()
    moment.locale(language)
    delete hash.language
    delete hash.taal
    delete hash.format
    delete hash.formaat
    date = moment(date)
    for (let key in hash) {
      let param = hash[key]
      if(key === 'eind') {
        key = 'endOf'
      }
      if(key === 'begin') {
        key = 'startOf'
      }
      if(key === 'plus') {
        key = 'add'
      }
      if(key ==='min') {
        key = 'subtract'
      }
      if (date[key]) {
        param = param.replace(/\bmaand\b/i, 'month')
        param = param.replace(/\bmaanden\b/i, 'months')
        param = param.replace(/\bjaar\b/i, 'year')
        param = param.replace(/\bjaren\b/i, 'years')
        param = param.replace(/\bdag\b/i, 'day')
        param = param.replace(/\bdagen\b/i, 'days')
        param = param.replace(/\bweek\b/i, 'week')
        param = param.replace(/\bweken\b/i, 'weeks')
        param = param.replace(/\bkwartaal\b/i, 'quarter')
        param = param.replace(/\bkwartalen\b/i, 'quarters')
        param = param.split(' '); // split up for add and subtract
        const momentOutput = date[key](...param)
        if (momentOutput.format) {
          return momentOutput.format(format)
        } else {
          return momentOutput;
        }
      } else {
        console.log('moment.js does not support "' + key + '"')
      }
    }

    return date.format(format)
  }

  // return new Handlebars.SafeString(moment(date).format(formatToUse))
  Handlebars.registerHelper('date', dateHelper)
  Handlebars.registerHelper('datum', dateHelper)

  const numberHelper = function (number, config) {
    if (!number || typeof number !== 'number') {
      number = 0
    }
    let options = {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
    if (arguments[1] && arguments[1].hash && arguments[1].hash) {
      options = {
        ...options,
        ...arguments[1].hash
      }
    }
    const locale =
      options.locale ||
      options.local ||
      options.lang ||
      options.language ||
      invoiceSettings.language ||
      'nl'
    return new Handlebars.SafeString(number.toLocaleString(locale, options))
  }

  Handlebars.registerHelper('nummer', numberHelper)
  Handlebars.registerHelper('number', numberHelper)
  // Handlebars.registerHelper('decimal', numberHelper)
  Handlebars.registerHelper('bedrag', numberHelper)
  Handlebars.registerHelper('amount', numberHelper)
  // Handlebars.registerHelper('money', numberHelper)

  const replaceVariables = (text = '', variables = {}, options) => {
    if (!text) return text
    try {
      const replace = Handlebars.compile(text)
      return replace(
        variables,
        options || { lang: 'nl', language: 'nl', locale: 'nl' }
      )
    } catch (e) {
      console.log(e)
      return text
    }
  }

  const defaultInvoiceSettings = {
    language: 'nl',
    invoiceTemplateId: '1',
    maxLinesPerPage: 20,
    accentColor: '#000000',
    textLogoColor: '#13C181',
    fontSize: 9,
    textColor: 'rgba(0, 0, 0, 0.7)', // rgba(0, 0, 0, 0.67)',
    fontFamily: 'Helvetica',
    // fontFamily: 'Arial',
    logoUrl: null,
    companyInformationPosition: 'top',
    invoiceInformationMarginTop: 4,
    noteMarginTop: 8,
    logoHeight: 36,
    logoMarginTop: 3,
    logoPosition: 'left',
    customerPosition: 'left',
    dateFormat: 'L'
  }

  const invoiceSettings = {
    ...defaultInvoiceSettings,
    ...invoiceSettingsInput
  }

  const invoice = { ...invoiceInput }
  const company = { ...invoiceSettings.companyInformation }
  const customer = { ...invoiceInput.customer }

  moment.locale(invoiceSettings.language)
  const invoiceDate = moment(invoice.invoiceDate)
  invoice.day = invoiceDate.format('dddd') // monday
  invoice.dayOfMonth = invoiceDate.date()
  invoice.week = invoiceDate.week()
  invoice.month = invoiceDate.format('MMMM') // august
  invoice.quarter = invoiceDate.format('Qo') // 1st quarter
  if (invoiceSettings.language === 'nl') {
    invoice.quarter = `${invoice.quarter} kwartaal`
  } else {
    invoice.quarter = `${invoice.quarter} quarter`
  }
  invoice.year = invoiceDate.year()

  const factuur = {
    factuurnummer: invoice.invoiceNumber,
    totaalbedrag: invoice.totalAmount,
    factuurdatum: invoice.invoiceDate,
    vervaldatum: invoice.dueDate,
    betalingstermijn: invoice.paymentTerm,
    dag: invoice.day,
    dagVanDeMaand: invoice.dayOfMonth,
    week: invoice.week,
    maand: invoice.month,
    kwartaal: invoice.quarter,
    jaar: invoice.year
  }

  const klant = {
    naam: customer.name,
    contactpersoon: customer.contactName,
    voornaam: customer.contactFirstName,
    achternaam: customer.contactLastName,
    contactpersoonVoornaam: customer.contactFirstName,
    contactpersoonAchternaam: customer.contactLastName
  }

  const address = company.address || {}
  const bedrijf = {
    naam: company.name,
    adres: {
      lijn1: address.line1,
      lijn2: address.line2,
      postcode: address.postalCode,
      plaats: address.city,
      land: address.country
    },
    website: company.website,
    email: company.email,
    telefoonnummer: company.phone,
    bankrekeningnummer: company.bankAccountNumber,
    kvkNummer: company.companyRegistrationNumber,
    btwIdNummer: company.vatIdentificationNumber
  }

  const variables = {
    invoice,
    customer,
    company,
    factuur,
    klant,
    bedrijf,
    invoiceSettings
  }

  invoice.Lines = (invoice.Lines || []).map((line) => {
    return {
      ...line,
      name: replaceVariables(line.name, variables),
      description: replaceVariables(line.description, variables)
    }
  })
  invoice.description = replaceVariables(invoice.description, variables)
  invoice.note = replaceVariables(invoice.note, variables)
  invoice.footer = replaceVariables(invoice.footer, variables)
  variables.invoice = invoice

  return {
    ...variables,
    replaceVariables
  }
}

export default getTemplateVariables
